import React from "react";
import "./Mobilex.css";
import Maploader from "./Maploader";

const Mobilex = ({
    imageSrc = "/Assets/mobile-expert.png",
    title = "İletişim",
    description = "Hizmetlerimiz, fiyatlandırma veya randevu oluşturma süreçleri hakkında merak ettiklerinizi bize iletin. Size özel çözümlerle kısa sürede geri dönüş yapacağız.",
    phone = "+90 535 883 75 10",
    phone2 = "+90 501 334 10 32",
}) => {

    return (
        <section className="mobilex-section" role="region" aria-label="Car hero section">
            <div className="mobilex-inner">
                <div className="mobilex-left">
                    <img src={imageSrc} onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/800x600/16a34a/white?text=Mobile+Expert+Car" }} alt="Car" className="mobilex-car" />
                    <div className="mobilex-contact-card">
                        <div className="contact-item">
                            <a href={`tel:${phone2}`} className="contact-value">
                                <span className="contact-label">Telefon:</span>
                                <br />
                                {phone2}
                            </a>
                        </div>
                        <div className="contact-item">
                            <a href={`tel:${phone2}`} className="contact-value">
                                <span className="contact-label">Whatsapp:</span>
                                <br />
                                {phone2}
                            </a>
                        </div>
                    </div>
                </div>
                <div className="mobilex-right">
                    <div className="mobilex-card">
                        <h2 className="mobilex-title">{title}</h2>
                        <div className="mobilex-location">
                            <Maploader />
                        </div>
                        <p className="mobilex-desc">{description}</p>
                        <a href="tel:+905013341032" className="call-btn" aria-label="Bizi arayin, telefon numarası">

                            <span className="btn-label">Bizi arayın</span>
                            <span className="btn-phone">+90 501 334 10 32</span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Mobilex;